import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./en";
import ar from "./ar";

export type Lang = "en" | "ar";

const STORAGE_KEY = "kb_lang";

export function getInitialLang(): Lang {
  const saved = localStorage.getItem(STORAGE_KEY);
  return saved === "ar" ? "ar" : "en";
}

/** Apply <html lang/dir> for the given language. */
export function applyDir(lang: Lang) {
  const html = document.documentElement;
  html.setAttribute("lang", lang);
  html.setAttribute("dir", lang === "ar" ? "rtl" : "ltr");
}

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    ar: { translation: ar },
  },
  lng: getInitialLang(),
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

applyDir(getInitialLang());

export async function setLang(lang: Lang) {
  localStorage.setItem(STORAGE_KEY, lang);
  applyDir(lang);
  await i18n.changeLanguage(lang);
}

export default i18n;
